import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscEyeFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M12 19.91c5.13 0 9.3-3.54 11.41-8-2.09-4.44-6.25-8-11.41-8-5.13 0-9.3 3.54-11.41 8 2.1 4.44 6.25 8 11.41 8ZM12 7.5c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5Z"
    />
  </svg>
);
export default SvgMiscEyeFill;
